import { INFORMATION_PATH } from 'profiles/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/ProfileInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/profiles/routes/show/routes/information/index.js